import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationCall16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { useCallbackButton } from './useCallbackButton';
import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';

export function HeaderCallbackButton() {
  const [isAvailable, handleClick, isLoading] = useCallbackButton('blockStickytop');
  const isFlatViewOrderEnabled = useSelector(getIsFlatViewOrderEnabled);

  if (!isAvailable) {
    return null;
  }

  return isFlatViewOrderEnabled ? (
    <Button
      theme="fill_secondary"
      size="XS"
      onClick={handleClick}
      beforeIcon={<IconCommunicationCall16 color={'primary_100'} />}
      loading={isLoading}
      data-testid="HeaderCallbackButton"
    />
  ) : (
    <Button
      theme="fill_secondary"
      size="XS"
      onClick={handleClick}
      loading={isLoading}
      data-testid="HeaderCallbackButton"
    >
      Заказ звонка
    </Button>
  );
}
